import { cx } from '@/lib/cx';
import styles from './GoldWave.module.css';

export interface GoldWaveProps {
  className?: string;
}

/* Cuatro curvas desfasadas, no una repetida: el mockup tiene vientres
 * asimétricos y densidad desigual. Cada trazo lleva su opacidad. */
const CURVES = [
  { d: 'M0 30 C 200 4, 380 52, 620 30 C 860 8, 1080 50, 1440 22', opacity: 0.55 },
  { d: 'M0 40 C 220 16, 420 60, 700 38 C 960 18, 1160 58, 1440 34', opacity: 0.4 },
  { d: 'M0 22 C 180 48, 400 8, 660 26 C 920 44, 1140 10, 1440 30', opacity: 0.32 },
  { d: 'M0 50 C 260 30, 460 66, 740 48 C 1020 30, 1220 64, 1440 44', opacity: 0.24 },
] as const;

/**
 * ONDULACIÓN DORADA — la bisagra entre el manifiesto y los tres pilares en
 * `DEMO_4_Mexico.png`. Banda de curvas capilares que cruzan el ancho completo.
 *
 * `preserveAspectRatio="none"` la estira al viewport y `vector-effect` mantiene
 * el trazo capilar a cualquier ancho, así que no engorda al ensanchar.
 * Pendiente en el substrato (PAGE_CONTRACT §10, "ondulación multi-curva"):
 * vive aquí hasta que FORGE-ALPHA la publique.
 */
export function GoldWave({ className }: GoldWaveProps) {
  return (
    <svg
      className={cx(styles.wave, className)}
      viewBox="0 0 1440 72"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      {CURVES.map((curve) => (
        <path key={curve.d} d={curve.d} opacity={curve.opacity} />
      ))}
    </svg>
  );
}
